import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "emergency-setting";

const GET_EMERGENCY_SETTING_URL = `${prefix}/get`;
const UPDATE_EMERGENCY_SETTING_URL = `${prefix}/update`;

/**
 * @func getEmergencySetting
 * @desc get emergency setting data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} emergency setting object
 */
export const getEmergencySetting = async signal => {
    try {
        const { data, status } = await axios.get(GET_EMERGENCY_SETTING_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getEmergencySetting");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getEmergencySetting */

/**
 * @func updateEmergencySetting
 * @desc update emergency setting
 * @author izeberg
 * @param {Object} body - update emergency setting body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateEmergencySetting = async (body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_EMERGENCY_SETTING_URL}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateEmergencySetting");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateEmergencySetting */
